import { blendWhite } from '@spritz-finance/ui'
import pageBackground from '../assets/theme/quickswap/quickswap-page-background.svg'
import hero from '../assets/theme/quickswap/hero.svg'
import dialogHeader from '../assets/theme/quickswap/quickswap-header-gradient.png'
import autoLoan from '../assets/theme/quickswap/icons/bill-type-auto-loan.png'
import mortgage from '../assets/theme/quickswap/icons/bill-type-mortgage.png'
import creditCard from '../assets/theme/quickswap/icons/bill-type-credit-card.png'
import studentLoan from '../assets/theme/quickswap/icons/bill-type-student-loan.png'
import utility from '../assets/theme/quickswap/icons/bill-type-utility.png'
import loan from '../assets/theme/quickswap/icons/bill-type-loan.png'
import more from '../assets/theme/quickswap/icons/bill-type-more.png'
import logo from '../assets/theme/quickswap/logo.svg'
import { ThemePackage } from './types'

import paySomeone from '../assets/icons/Quick_Pay someone@4x.png'
import findBills from '../assets/icons/Quick_Icon_Search@2x.png'

// const textPrimary = '#ebecf2'
const textSecondary = '#C7CAD9'
const textTertiary = '#696C80'
const primary = '#448AFF'
const primaryDark = '#1e2f51'

const surface1 = '#1B1E29'
const surface2 = '#282D3D'
const surface3 = '#404557'

const success = '#0FC679'
const error = '#FF5C5C'

export const quickswapTheme: ThemePackage = {
    images: {
        billTypeAutoLoan: autoLoan,
        billTypeMortgage: mortgage,
        billTypeCreditCard: creditCard,
        billTypeStudentLoan: studentLoan,
        billTypeUtility: utility,
        billTypeLoan: loan,
        billTypeMore: more,
        hero,
        appLogo: logo,
        paySomeone,
        findBills,
    },
    componentVariables: {
        pageBackground,
    },
    cssVariables: {
        // img urls
        logoHeight: '60px',
        dialogHeaderUrl: `url(${dialogHeader})`,
        // brand colors
        colorBrand: primary,
        colorBrand75: blendWhite(primary, 0.25),
        colorBrand50: blendWhite(primary, 0.5),
        // text colors
        textPrimary: textSecondary,
        textSecondary: textTertiary,
        textContrast: surface1,
        textError: error,
        textSuccess: success,
        //button colors
        buttonCtaPrimary: primary,
        buttonCtaPrimaryFocus: primaryDark,
        buttonBackgroundGradient: 'linear-gradient(180deg, #518AF7 0%, #1752DE 100%)',
        // backgrounds
        backgroundPrimary: '#1B1E28',
        backgroundSecondary: '#12131A',
        surface1,
        surface2,
        surface3,
        // shadows
        cardHoverShadow: 'rgba(240, 240, 240, 0.15)',
        // pageBackground: '#12131A',
        pageBackground: `url(${pageBackground}), #12131A`,
        tabPillBackground: textSecondary,
        backdropBlur: 'blur(9.9px)',
        backdropBackground: 'rgba(0, 0, 0, 0.5)',
        overlayBackground: 'rgba(0, 0, 0, 0.1)',
        walletBackground: surface2,
        walletPill: surface3,
        // font
        fontName: 'Inter',
    },
}
